<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>报备审核</h1>
        <p>普通客户保护 90 天，战略客户 180 天。已用邀请码绑定的用户不会改归属。</p>
      </div>
    </div>
    <div class="ch-metrics three">
      <div class="ch-metric"><div class="k">报备</div><div class="v">{{ list.length }}</div></div>
      <div class="ch-metric"><div class="k">待审核</div><div class="v">{{ count('PENDING') }}</div></div>
      <div class="ch-metric"><div class="k">保护期中</div><div class="v">{{ count('PROTECTED') }}</div></div>
    </div>
    <div class="ch-panel">
      <table class="ch-table">
        <thead><tr><th>渠道</th><th>客户</th><th>类型</th><th>预估年采购额</th><th>备注</th><th>提交时间</th><th>保护期截止</th><th>状态</th><th>操作</th></tr></thead>
        <tbody>
          <tr v-for="row in list" :key="row.id">
            <td>{{ nameOf(row.partnerId) }}</td>
            <td>{{ row.customerName }}</td>
            <td>{{ row.customerType }}</td>
            <td>{{ row.estimatedAmount != null ? '¥ ' + yuan(row.estimatedAmount) : '—' }}</td>
            <td>{{ row.remark || '—' }}</td>
            <td>{{ row.createdAt }}</td>
            <td>{{ row.protectUntil || '—' }}</td>
            <td><span class="ch-tag" :class="row.status === 'PROTECTED' ? 'ok' : 'warn'">{{ statusName(row.status) }}</span></td>
            <td>
              <button v-if="row.status === 'PENDING'" class="ch-link" type="button" @click="review(row, 'approve')">通过</button>
              <button v-if="row.status === 'PENDING'" class="ch-link" type="button" @click="review(row, 'reject')">驳回</button>
            </td>
          </tr>
          <tr v-if="!list.length"><td colspan="8" class="ch-empty">还没有报备</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelPartners, getChannelReports, reviewChannelReport } from '@/api/admin'
import { statusName, yuan } from '../partner/labels'
import { partnerName } from './lookup'

export default {
  name: 'HqReports',
  data() { return { partners: [], list: [] } },
  created() { this.load() },
  methods: {
    statusName, yuan,
    nameOf(id) { return partnerName(this.partners, id) },
    count(status) { return this.list.filter(item => item.status === status).length },
    async load() {
      const partners = await getChannelPartners()
      const reports = await getChannelReports()
      this.partners = partners.list || []
      this.list = reports.list || []
    },
    async review(row, action) {
      await reviewChannelReport(row.id, { action, customerType: row.customerType })
      this.load()
    }
  }
}
</script>
